module.exports = "<header><a id=headline v-link=\"{ path: '/targets' }\"></a><a id=tech-logo v-link=\"{ path: '/' }\"><img v-bind:src=logo /></a></header><div id=header-bottom></div><router-view></router-view><section id=bg></section><footer><h3>STAND WITH US. SUPPORT AN HDR FUTURE FOR ALL. <a v-link=\"{ path: '/' }\">technicolor.com/hdr </a></h3></footer>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./public/_src/_vue/app-shell.vue
 ** module id = 35
 ** module chunks = 0
 **/